import Abertura from './Abertura'

const Home = () => (
  <>
    <Abertura />
  </>
)

export default Home
